<template>
  <div
    ref="carouselContainer"
    class="
      pre-header-banner
      critical-component-clear
      liquid
      text-center
      splide
    "
    :class="{ 'pre-header-banner--stack': banners.length === 2 }"
    role="complementary"
    :style="`--ph-background: var(${backgroundColor}); --ph-text-color: var(${textColor})`"
    aria-label="Pre-header carousel"
    js-carousel="pre-header"
  >
    <div
      v-if="banners.length"
      class="splide__track"
    >
      <ul class="splide__list">
        <template
          v-for="(banner, index) in banners"
          :key="index"
        >
          <li
            class="splide__slide text-body-2xs"
            v-html="banner.message"
          />
          <hr v-if="index === 0 && banners.length === 2">
        </template>
      </ul>
    </div>
  </div>
</template>

<script>

/**
 * Component / Global: Site header
 * -----------------------------------------------------------------------------
 * Site header component, contains menu drawer and meganav.
 * - No style import as it's included in critical stylesheet.
 *
 */
import Carousel from '~/api/carousel'

export default {
  name: 'PreHeaderBanner',

  props: {
    textColorTheme: {
      type: String,
      default: 'light',
    },
    backgroundColor: {
      type: String,
      default: '--color-background-black',
    },
    autoplayEnable: {
      type: Boolean,
      default: true,
    },
    autoplaySpeed: {
      type: String,
      default: '2500',
    },
    banners: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      selectors: {
        container: '[js-carousel="pre-header"]',
      },
    }
  },

  computed: {
    textColor() {
      return this.textColorTheme === 'light'
        ? '--color-text-inverse'
        : '--color-text-primary'
    },
  },

  mounted() {
    if (this.banners.length === 2) {
      return
    }

    this.createCarousel()
  },

  methods: {

    /**
     * Main carousel contructor function
     */
    async createCarousel() {
      await this.$nextTick()
      const container = this.$refs.carouselContainer

      if (!container) {
        return
      }

      const autoplay = this.autoplayEnable
      const interval = Number(this.autoplaySpeed)

      Carousel(
        this.selectors.container,
        {
          type: 'fade',
          rewind: true,
          autoplay,
          interval,
        },
      ).mount()
    },
  },
}
</script>
